import PerguntaService from '../../services/PerguntaService'
import notificacaoService from '../../services/Notificacao.service'


function  monitorarValidacaoRespostaInvalida(codigoValidacao, respostas, $thisRef, callback) {


  let timer = window.setInterval(() => {

    const { perguntasRespondidas } = $thisRef.$store.state;
    let mudouValor = false;
    //monitor
    for (var resposta of respostas) {
      //verificar se houve mudança em alguma resposta
      for (let perguntaRespondida of perguntasRespondidas) {
        const [respostaAtualizada] = perguntaRespondida.respostas.filter(r => r.perguntaId == resposta.perguntaId);
        if (resposta && respostaAtualizada && resposta.valorResposta != respostaAtualizada.valor) {
          mudouValor = true;
          break;
        }
      }
    }

    if (mudouValor) {
      window.clearInterval(timer);
      timer = null;
      callback && typeof (callback) == "function" && callback();
    }



  }, 1000);

}

const computed = {
  isDebug(){
    return this.$store.state.isDebug;
  },
}
export default {
  computed,
  methods: {
    responderPerguntaMixin(payload) {

      // aplicar validações quando necessário
      this.$store.dispatch('responderPergunta', payload)
    },
    removerRespostaMixin(opcaoResposta) {
      this.$store.dispatch('removerRespostaPergunta', opcaoResposta);
    },
    removerTodasRespostasPergunta(sessaoFormularioPerguntaId) {
      this.$store.dispatch('limparRespostasPergunta', sessaoFormularioPerguntaId)
    },
    adicionarRestriacaoDePreValidacaoResposta(codigoPreValidacao) {
      this.$store.dispatch('adicionarRestriacaoDePreValidacaoResposta', codigoPreValidacao)
    },
    removerRestriacaoDePreValidacaoResposta(codigoPreValidacao) {
      this.$store.dispatch('removerRestriacaoDePreValidacaoResposta', codigoPreValidacao)
    },
    verificarPerguntaEncadeada(encadeamentoPergunta) {
      this.$store.dispatch('verificarPerguntaEncadeada', encadeamentoPergunta);
    },
    async aplicarValidacaoPorValorMixin() {
      
      const { perguntaId } = this.pergunta;
      const { perguntasRespondidas } = this.$store.state;
      const perguntasValidarRespostaPorValor = this.$store.getters.perguntasValidarRespostaPorValor || [];
      const [perguntaComValidacao] = perguntasValidarRespostaPorValor
        .filter(p => p.perguntaId == perguntaId);

      if (!perguntaComValidacao)
        return;

      const { codigo } = perguntaComValidacao;
      const { preValidacoesRespostas } = this.$store.state.formulario;
      const [prevalidacaoResposta] = preValidacoesRespostas.filter(pv => pv.codigo == codigo);
      let mensagemPrevalidacao = '';

      if(!prevalidacaoResposta) return;

      if (prevalidacaoResposta && prevalidacaoResposta.descricao) {
        mensagemPrevalidacao = prevalidacaoResposta.mensagemValidacao;
      }

      const {preValidacoesRespostaPergunta} = prevalidacaoResposta;
      let podeContinuarValidacao = false;
      const perguntasPreValidacaoComRespostas = [];
      //verificar se as perguntas que fazem parte da pre-validação estão respondidadas
      preValidacoesRespostaPergunta.forEach(perguntaPreValidacao=> {
        const temResposta = perguntasRespondidas.filter(pr => pr.perguntaId == perguntaPreValidacao.perguntaId).length > 0;
        if(temResposta)
          perguntasPreValidacaoComRespostas.push(perguntaPreValidacao);
      });

      //se tem a mesma qtd de perguntas respondidas continuar a validação;.
      podeContinuarValidacao = perguntasPreValidacaoComRespostas.length == preValidacoesRespostaPergunta.length;
      console.log('continuar...', podeContinuarValidacao);

      if(!podeContinuarValidacao) return;

      const payloadValidacaoResposta = {
        id: 0,
        codigoValidacao: codigo,
        preValidacaoRespostasPerguntas: []
      }

      const validacoesResposta = [];


      if (perguntaComValidacao && perguntaComValidacao.gatilhoValidacao) {

        

        //obter as perguntas que compoe a validação
        const perguntasValidacao = perguntasValidarRespostaPorValor.filter(p => p.codigo == codigo);
        const perguntaTemValorRessposta = perguntasRespondidas.filter(pr => pr.perguntaId == perguntaId).length > 0;

        if (perguntasValidacao && perguntasValidacao.length && perguntaTemValorRessposta) {
          perguntasValidacao.forEach(pergValidacao => {

            //perguntaId
            const [perguntaRespondida] = perguntasRespondidas.filter(pr => pr.perguntaId == pergValidacao.perguntaId);

            //obter o valor de resposta
            const [respostaPergunta] = perguntaRespondida.respostas.filter(rp => rp.perguntaId == pergValidacao.perguntaId);

            if (respostaPergunta && respostaPergunta.valor) {
              validacoesResposta.push({
                chave: pergValidacao.chavePergunta,
                perguntaId: respostaPergunta.perguntaId,
                valorResposta: respostaPergunta.valor,
                textoExibicao: pergValidacao.textoExibicao
              })
            }
          });

        }

        if (validacoesResposta && validacoesResposta.length) {
          payloadValidacaoResposta.preValidacaoRespostasPerguntas = [...validacoesResposta];

          const { erros, estaValido } = await PerguntaService.validarRespostaPorValor(payloadValidacaoResposta);

          if (!estaValido && erros && erros.length) {

            mensagemPrevalidacao += "<br>";
            validacoesResposta.forEach(validacaoResposta => {
              mensagemPrevalidacao += "<br>";
              mensagemPrevalidacao += `${validacaoResposta.textoExibicao}: ${validacaoResposta.valorResposta}`
            });

            //informar que existe uma restrição de validação
            this.adicionarRestriacaoDePreValidacaoResposta(codigo);

            monitorarValidacaoRespostaInvalida(codigo, validacoesResposta, this, () => {
              this.removerRestriacaoDePreValidacaoResposta(codigo);
              this.aplicarValidacaoPorValorMixin();
            })

            notificacaoService.confirmacao("Atenção", mensagemPrevalidacao)
              .then(confirmou => {
                const { value: okClick, dismiss } = confirmou
                if (okClick) {
                  this.removerRestriacaoDePreValidacaoResposta(codigo)
                }

              })

          } else if (estaValido) {
            this.removerRestriacaoDePreValidacaoResposta(codigo)
          }
        }
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/PerguntasComponent/ResponderPerguntaMixin.js